<div class="gradient-bar-wrapper" [class.gradient-bar-wrapper-flush]="noMargins()">
  <div class="gradient-bar">
    <div class="gradient-segment gradient-segment-1"></div>
    <div class="gradient-segment gradient-segment-2"></div>
    <div class="gradient-segment gradient-segment-3"></div>
    <div class="gradient-segment gradient-segment-4"></div>
  </div>
</div>